export const municipalidadState = {
    listado: [],
    isLoading: false,
    message: '',
    severity: '',
}